<template>
  <div id="dashboard">
    <h1></h1>
  </div>
</template>

<script>
export default {
  name: 'Dashboard',
  data () {
    return {
    }
  },
  async beforeMount () {
    this.$router.push({ path: '/permissions' })
  }
}
</script>
